export default __webpack_public_path__ + "static/media/warning-orange.3c0157c7.svg";